import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { Drawer } from '@dtx-company/shared-components/src/components/organisms/Drawer'
import { DrawerFAQsList } from '../../../components/organisms/DrawerFAQsList/DrawerFAQsList'
import { DrawerTypes } from '@dtx-company/inter-app/src/redux/slices/drawer'
import { FC } from 'react'
import { TEMPLATE_FAQS_LIST } from './TemplateFAQs.constants'
import { useDrawer } from '@dtx-company/inter-app/src/redux/slices/utils/drawer'

export const TemplateFAQs: FC = () => {
  const { setClose: closeDrawer, drawerOpen } = useDrawer(DrawerTypes.TEMPLATES_FAQS)
  return (
    <Drawer open={drawerOpen} onClose={closeDrawer}>
      <Box mt={'24px'} flexDirection="column">
        <DrawerFAQsList title="Template FAQs" faqs={TEMPLATE_FAQS_LIST} />
      </Box>
    </Drawer>
  )
}
